import apiService from './apiService';

/**
 * Service for managing alert routing rules
 */
class RoutingService {
  /**
   * Get all routing rules for the organization
   */
  async getRoutingRules() {
    return apiService.get('/routing-rules');
  }

  /**
   * Create a new routing rule
   * @param {Object} ruleData - Rule configuration
   * @param {string} ruleData.rule_name - Name of the rule
   * @param {string} ruleData.match_type - Type: 'table', 'metric', 'severity', 'validation_rule', 'pattern'
   * @param {string} ruleData.match_value - Value to match
   * @param {string[]} ruleData.notification_channels - Channels: ['email', 'slack', 'webhook']
   * @param {string} [ruleData.slack_channel] - Override Slack channel
   * @param {string[]} [ruleData.email_recipients] - Override email recipients
   * @param {string} [ruleData.min_severity] - Minimum severity: 'low', 'medium', 'high', 'critical'
   * @param {number} [ruleData.priority] - Rule priority (lower = higher priority)
   */
  async createRoutingRule(ruleData) {
    return apiService.post('/routing-rules', ruleData);
  }

  /**
   * Update an existing routing rule
   * @param {string} ruleId - ID of the rule to update
   * @param {Object} ruleData - Updated rule configuration
   */
  async updateRoutingRule(ruleId, ruleData) {
    return apiService.put(`/routing-rules/${ruleId}`, ruleData);
  }

  /**
   * Delete a routing rule
   * @param {string} ruleId - ID of the rule to delete
   */
  async deleteRoutingRule(ruleId) {
    return apiService.delete(`/routing-rules/${ruleId}`);
  }

  /**
   * Toggle rule active status
   * @param {string} ruleId - ID of the rule
   * @param {boolean} isActive - New active status
   */
  async toggleRuleActive(ruleId, isActive) {
    return apiService.put(`/routing-rules/${ruleId}`, { is_active: isActive });
  }
}

const routingService = new RoutingService();
export default routingService;
